"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _d3Brush = require("d3-brush");

var _d3Selection = require("d3-selection");

var _Brush = _interopRequireDefault(require("./Brush"));

var _SpanOrDiv = require("./SpanOrDiv");

var _InteractionItems = require("./processing/InteractionItems");

var _InteractionCanvas = _interopRequireDefault(require("./interactionLayerBehavior/InteractionCanvas"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var generateOMappingFn = function generateOMappingFn(projectedColumns) {
  return function (d) {
    if (d) {
      var columnValues = Object.values(projectedColumns);
      var foundColumns = columnValues.filter(function (c) {
        return d[1] >= c.x && d[0] <= c.x + c.width;
      });
      return foundColumns;
    }

    return null;
  };
};

var generateOEndMappingFn = function generateOEndMappingFn(projectedColumns) {
  return function (d) {
    if (d && _d3Selection.event.sourceEvent && _d3Selection.event.sourceEvent.path && _d3Selection.event.sourceEvent.path[1] && _d3Selection.event.sourceEvent.path[1].classList.contains("xybrush") && _d3Selection.event.target.move) {
      var columnValues = Object.values(projectedColumns);
      var foundColumns = columnValues.filter(function (c) {
        return d[1] >= c.x && d[0] <= c.x + c.width;
      });
      var firstColumn = foundColumns[0] || {
        x: 0,
        width: 0
      };
      var lastColumn = foundColumns[foundColumns.length - 1] || {
        x: 0,
        width: 0
      };
      var columnPosition = [firstColumn.x + Math.min(5, firstColumn.width / 10), lastColumn.x + lastColumn.width - Math.min(5, lastColumn.width / 10)];
      (0, _d3Selection.select)(_d3Selection.event.sourceEvent.path[1]).transition(750).call(_d3Selection.event.target.move, columnPosition);
      return foundColumns;
    }

    return null;
  };
};

var InteractionLayer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(InteractionLayer, _React$PureComponent);

  function InteractionLayer(props) {
    var _this;

    _classCallCheck(this, InteractionLayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InteractionLayer).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "createBrush", function (interaction) {
      var semioticBrush, mappingFn, selectedExtent, endMappingFn;
      var _this$props = _this.props,
          xScale = _this$props.xScale,
          yScale = _this$props.yScale,
          size = _this$props.size,
          renderPipeline = _this$props.renderPipeline;
      var brushData = {};
      Object.entries(renderPipeline).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        if (value.data && value.data.length > 0) {
          brushData[key] = value.data;
        }
      });
      var projection = interaction.projection,
          projectedColumns = interaction.projectedColumns;
      var actualBrush = interaction.brush === "oBrush" ? projection === "horizontal" ? "yBrush" : "xBrush" : interaction.brush;
      var _interaction$extent = interaction.extent,
          extent = _interaction$extent === void 0 ? actualBrush === "xyBrush" ? [[xScale.invert(0), yScale.invert(0)], [xScale.invert(size[0]), yScale.invert(size[1])]] : actualBrush === "xBrush" ? [xScale.invert(0), xScale.invert(size[0])] : [yScale.invert(0), yScale.invert(size[1])] : _interaction$extent;

      if (extent.indexOf && extent.indexOf(undefined) !== -1) {
        return React.createElement("g", null);
      }

      if (actualBrush === "xBrush") {
        var castExtent = extent;

        mappingFn = function mappingFn(d) {
          return !d ? null : [xScale.invert(d[0]), xScale.invert(d[1])];
        };

        semioticBrush = (0, _d3Brush.brushX)();
        selectedExtent = castExtent.map(function (d) {
          return xScale(d);
        });
        endMappingFn = mappingFn;
      } else if (actualBrush === "yBrush") {
        var _castExtent = extent;

        mappingFn = function mappingFn(d) {
          return !d ? null : [yScale.invert(d[0]), yScale.invert(d[1])].sort(function (a, b) {
            return a - b;
          });
        };

        semioticBrush = (0, _d3Brush.brushY)();
        selectedExtent = _castExtent.map(function (d) {
          return yScale(d);
        }).sort(function (a, b) {
          return a - b;
        });
        endMappingFn = mappingFn;
      } else {
        var _castExtent2 = extent;

        if (_castExtent2.indexOf(undefined) !== -1 || _castExtent2[0].indexOf(undefined) !== -1 || _castExtent2[1].indexOf(undefined) !== -1) {
          return React.createElement("g", null);
        }

        semioticBrush = (0, _d3Brush.brush)();

        mappingFn = function mappingFn(d) {
          if (!d) return null;
          var yValues = [yScale.invert(d[0][1]), yScale.invert(d[1][1])].sort(function (a, b) {
            return a - b;
          });
          return [[xScale.invert(d[0][0]), yValues[0]], [xScale.invert(d[1][0]), yValues[1]]];
        };

        var yValues = [yScale(extent[0][1]), yScale(extent[1][1])].sort(function (a, b) {
          return a - b;
        });
        selectedExtent = _castExtent2.map(function (d, i) {
          return [xScale(d[0]), yValues[i]];
        });
        endMappingFn = mappingFn;
      }

      if (interaction.brush === "oBrush") {
        selectedExtent = null;

        if (interaction.extent) {
          var _interaction$extent2 = _slicedToArray(interaction.extent, 2),
              leftExtent = _interaction$extent2[0],
              rightExtent = _interaction$extent2[1];

          if ((typeof leftExtent === "string" || typeof leftExtent === "number") && (typeof rightExtent === "string" || typeof rightExtent === "number")) {
            selectedExtent = [projectedColumns[leftExtent].x, projectedColumns[rightExtent].x + projectedColumns[rightExtent].width];
          }
        }

        mappingFn = generateOMappingFn(projectedColumns);
        endMappingFn = generateOEndMappingFn(projectedColumns);
      }

      semioticBrush.extent([[0, 0], [size[0], size[1]]]).on("start", function () {
        (0, _InteractionItems.brushStart)(mappingFn(_d3Selection.event.selection), undefined, brushData, undefined, interaction);
      }).on("brush", function () {
        (0, _InteractionItems.brushing)(mappingFn(_d3Selection.event.selection), undefined, brushData, undefined, interaction);
      }).on("end", function () {
        (0, _InteractionItems.brushEnd)(endMappingFn(_d3Selection.event.selection), undefined, brushData, undefined, interaction);
      });
      return React.createElement("g", {
        className: "brush"
      }, React.createElement(_Brush.default, {
        selectedExtent: selectedExtent,
        extent: extent,
        svgBrush: semioticBrush
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "createColumnsBrush", function (interaction) {
      var _this$props2 = _this.props,
          projection = _this$props2.projection,
          rScale = _this$props2.rScale,
          oColumns = _this$props2.oColumns,
          renderPipeline = _this$props2.renderPipeline;
      if (!projection || !rScale || !oColumns) return;
      var brushData = {};
      Object.entries(renderPipeline).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        if (value.data && value.data.length > 0) {
          brushData[key] = value.data;
        }
      });
      var semioticBrush, mappingFn;
      var rScaleReverse = rScale.copy().domain(rScale.domain()).range(rScale.domain().reverse());

      if (projection && projection === "horizontal") {
        mappingFn = function mappingFn(d) {
          return !d ? null : [rScale.invert(d[0]), rScale.invert(d[1])];
        };
      } else mappingFn = function mappingFn(d) {
        return !d ? null : [rScaleReverse(rScale.invert(d[1])), rScaleReverse(rScale.invert(d[0]))];
      };

      var rRange = rScale.range();
      var columnHash = oColumns;
      var brushPosition, selectedExtent;
      var brushes = Object.keys(columnHash).map(function (c) {
        if (projection && projection === "horizontal") {
          selectedExtent = interaction.extent[c] ? interaction.extent[c].map(function (d) {
            return rScale(d);
          }) : interaction.startEmpty ? null : rRange;
          brushPosition = [0, columnHash[c].x];
          semioticBrush = (0, _d3Brush.brushX)();
          semioticBrush.extent([[rRange[0], 0], [rRange[1], columnHash[c].width]]).on("start", function () {
            (0, _InteractionItems.brushStart)(mappingFn(_d3Selection.event.selection), c, brushData, columnHash[c], interaction);
          }).on("brush", function () {
            (0, _InteractionItems.brushing)(mappingFn(_d3Selection.event.selection), c, brushData, columnHash[c], interaction);
          }).on("end", function () {
            (0, _InteractionItems.brushEnd)(mappingFn(_d3Selection.event.selection), c, brushData, columnHash[c], interaction);
          });
        } else {
          selectedExtent = interaction.extent[c] ? interaction.extent[c].map(function (d) {
            return rRange[1] - rScale(d);
          }).reverse() : interaction.startEmpty ? null : rRange;
          brushPosition = [columnHash[c].x, 0];
          semioticBrush = (0, _d3Brush.brushY)();
          semioticBrush.extent([[0, rRange[0]], [columnHash[c].width, rRange[1]]]).on("start", function () {
            (0, _InteractionItems.brushStart)(mappingFn(_d3Selection.event.selection), c, brushData, columnHash[c], interaction);
          }).on("brush", function () {
            (0, _InteractionItems.brushing)(mappingFn(_d3Selection.event.selection), c, brushData, columnHash[c], interaction);
          }).on("end", function () {
            (0, _InteractionItems.brushEnd)(mappingFn(_d3Selection.event.selection), c, brushData, columnHash[c], interaction);
          });
        }

        return React.createElement("g", {
          key: "column-brush-".concat(c),
          className: "brush"
        }, React.createElement(_Brush.default, {
          key: "orbrush".concat(c),
          selectedExtent: selectedExtent,
          svgBrush: semioticBrush,
          position: brushPosition
        }));
      });
      return brushes;
    });

    var canvasMap = new Map();
    var canvasRendering = props.canvasRendering,
        useSpans = props.useSpans,
        svgSize = props.svgSize,
        margin = props.margin,
        voronoiHover = props.voronoiHover;
    var initialOverlayRegions = (0, _InteractionItems.calculateOverlay)(props);
    _this.state = {
      overlayRegions: initialOverlayRegions,
      canvasMap: canvasMap,
      interactionCanvas: canvasRendering && React.createElement(_InteractionCanvas.default, {
        height: svgSize[1],
        width: svgSize[0],
        overlayRegions: initialOverlayRegions,
        margin: margin,
        voronoiHover: voronoiHover
      }),
      props: props,
      SpanOrDiv: (0, _SpanOrDiv.HOCSpanOrDiv)(useSpans)
    };
    return _this;
  }

  _createClass(InteractionLayer, [{
    key: "render",
    value: function render() {
      var semioticBrush = null;
      var _this$props3 = this.props,
          interaction = _this$props3.interaction,
          svgSize = _this$props3.svgSize,
          margin = _this$props3.margin,
          _this$props3$useSpans = _this$props3.useSpans,
          useSpans = _this$props3$useSpans === void 0 ? false : _this$props3$useSpans;
      var _this$state = this.state,
          overlayRegions = _this$state.overlayRegions,
          interactionCanvas = _this$state.interactionCanvas,
          SpanOrDiv = _this$state.SpanOrDiv;
      var enabled = this.props.enabled;

      if (interaction && interaction.brush) {
        enabled = true;
        semioticBrush = this.createBrush(interaction);
      }

      if (interaction && interaction.columnsBrush) {
        enabled = true;
        semioticBrush = this.createColumnsBrush(interaction);
      }

      if (!overlayRegions && !semioticBrush) {
        return null;
      }

      return React.createElement(SpanOrDiv, {
        span: useSpans,
        className: "interaction-layer",
        style: {
          position: "absolute",
          background: "none",
          pointerEvents: "none"
        }
      }, interactionCanvas || React.createElement("svg", {
        height: svgSize[1],
        width: svgSize[0],
        style: {
          background: "none",
          pointerEvents: "none"
        }
      }, React.createElement("g", {
        className: "interaction-overlay",
        transform: "translate(".concat(margin.left, ",").concat(margin.top, ")"),
        style: {
          pointerEvents: enabled ? "all" : "none"
        }
      }, React.createElement("g", {
        className: "interaction-regions"
      }, overlayRegions), semioticBrush)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var props = prevState.props;

      if (props.overlay !== nextProps.overlay || nextProps.points !== props.points || props.xScale !== nextProps.xScale || props.yScale !== nextProps.yScale || !props.hoverAnnotation && nextProps.hoverAnnotation || props.hoverAnnotation && !nextProps.hoverAnnotation) {
        var disableCanvasInteraction = nextProps.disableCanvasInteraction,
            canvasRendering = nextProps.canvasRendering,
            svgSize = nextProps.svgSize,
            margin = nextProps.margin,
            voronoiHover = nextProps.voronoiHover;
        var overlayRegions = prevState.overlayRegions;
        var nextOverlay, interactionCanvas;

        if (disableCanvasInteraction || !overlayRegions) {
          nextOverlay = null;
          interactionCanvas = null;
        } else {
          nextOverlay = (0, _InteractionItems.calculateOverlay)(nextProps);

          if (canvasRendering) {
            interactionCanvas = React.createElement(_InteractionCanvas.default, {
              height: svgSize[1],
              width: svgSize[0],
              overlayRegions: nextOverlay,
              margin: margin,
              voronoiHover: voronoiHover
            });
          }
        }

        return {
          overlayRegions: nextOverlay,
          props: nextProps,
          interactionCanvas: interactionCanvas
        };
      }

      return null;
    }
  }]);

  return InteractionLayer;
}(React.PureComponent);

_defineProperty(InteractionLayer, "defaultProps", {
  svgSize: [500, 500]
});

var _default = InteractionLayer;
exports.default = _default;
module.exports = exports.default;